import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=744f6c8f&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744f6c8f')) {
      api.createRecord('744f6c8f', component.options)
    } else {
      api.reload('744f6c8f', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=744f6c8f&", function () {
      api.rerender('744f6c8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-83M8h9S4UjSHY/JS/comp/FavElement.vue"
export default component.exports